module.exports = __webpack_public_path__ + "img/ct.fcfb0c2b.png";